import { Variants, easeInOut } from 'framer-motion';

export const textAnimation: Variants = {
  offscreen: {
    opacity: 0,
    y: 50
  },
  onscreen: {
    opacity: 1,
    y: 0,
    // scale: [0, 1],
    // x: [50, 0],
    // translateY: [50 ,0,],
    transition: { duration: 0.7 }
  }
};

export const cardAnimation: Variants = {
  offscreen: {
    opacity: 0,
    x: -100
  },
  onscreen: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};

export const hero: Variants = {
  offscreen: {
    opacity: 0
    // x: -100
  },
  onscreen: {
    opacity: 1,
    // x: 0,
    transition: {
      duration: 0.5,
      easeInOut
    }
  }
};

export const container = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    // scale: 1,
    transition: {
      delayChildren: 0.2,
      staggerChildren: 0.1
    }
  }
};
export const cardContainer = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    // scale: 1,
    transition: {
      delayChildren: 0.5,
      staggerChildren: 0.2
    }
  }
};

export const item = {
  hidden: { x: 0, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      ease: 'linear',
      duration: 0.5
    }
  }
};
export const textItem = {
  hidden: { y: 50, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      ease: 'linear',
      duration: 0.3
    }
  }
};
